import { atom } from 'jotai';
import { atomWithStorage, useResetAtom } from 'jotai/utils';

import { logger } from '@service-initiation/shared-clients-osp-logger';
import { storage } from '@service-initiation/shared-utils-jotai';

import { COMPANY_CODES } from '../utils';

const companyIdAtomWithStorage = atomWithStorage<number | undefined>(
  'si-tec-car-company-id',
  undefined,
  storage<number | undefined>(),
  {
    getOnInit: true,
  }
);

export const companyIdAtom = atom(
  (get) => {
    return get(companyIdAtomWithStorage);
  },
  (_get, set, value: number) => {
    if (value in COMPANY_CODES) {
      set(companyIdAtomWithStorage, value);
    } else {
      logger.error('Invalid company code', {
        invalidCompanyCode: value,
        validCompanyCodes: Object.keys(COMPANY_CODES),
      });
      set(companyIdAtomWithStorage, undefined);
    }
  }
);

export const useResetCompanyIdAtom = () => {
  const resetCompanyId = useResetAtom(companyIdAtomWithStorage);

  return resetCompanyId;
};
